/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { generateUrl } from '../../../routes/util';
import { Menu } from '@g17eco/molecules/menu/Menu';
import { NavCode } from '../constants';

export const TemplateNav = () => {
  const history = useHistory();
  const { initiativeId, templateId, page } = useParams<{ initiativeId: string; templateId: string; page: string }>();
  const isCreating = !templateId;
  const templateRoutes = {
    ...ROUTES.SURVEY_TEMPLATES,
    path: `${ROUTES.SURVEY_TEMPLATES.path}/template/:templateId/:page`,
  };

  const getItem = (code: NavCode, label: string) => {
    const isActive = code === page || (isCreating && code === NavCode.Configuration);

    const onClick = () => {
      return history.push({
        pathname: generateUrl(templateRoutes, { initiativeId, templateId, page: code }),
        search: history.location.search,
      });
    };

    return {
      active: isActive,
      disabled: isCreating,
      onClick,
      label
    }
  };

  return (
    <>
      <Menu className='mt-3' items={[
        getItem(NavCode.Configuration, 'Configuration'),
        getItem(NavCode.Scope, 'Template scope')
      ]} />
      <hr />
    </>
  );
};
